(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-home-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-home-film')) {
    customElements.define('hf-home-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        const video = this.querySelector('video');
        const toggle = this.querySelector('button');
        if (!video || !toggle) return;
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        let inView = true;
        let explicitPause = false;
        let wantsPlayback = !motion.matches && !connection?.saveData;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        const updateControl = () => {
          const playing = !video.paused;
          this.toggleAttribute('data-playing', playing);
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          toggle.querySelector('span').textContent = label;
          toggle.setAttribute('aria-label', label);
        };
        const syncPlayback = () => {
          if (!wantsPlayback || !inView || document.hidden) {
            video.pause();
            updateControl();
            return;
          }
          video.play().catch(updateControl);
        };
        toggle.hidden = false;
        updateControl();
        toggle.addEventListener('click', () => {
          wantsPlayback = video.paused;
          explicitPause = !wantsPlayback;
          syncPlayback();
        }, options);
        video.addEventListener('play', updateControl, options);
        video.addEventListener('pause', updateControl, options);
        video.addEventListener('error', () => {toggle.hidden = true;}, options);
        document.addEventListener('visibilitychange', syncPlayback, options);
        motion.addEventListener('change', () => {
          wantsPlayback = !motion.matches && !explicitPause && !connection?.saveData;
          syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            inView = entries[0].isIntersecting;
            syncPlayback();
          }, {threshold: 0.05});
          this.observer.observe(this);
        }
        syncPlayback();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-home-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-product-discovery')) {
  customElements.define('hf-product-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const nav = this.querySelector('.hf-discovery__tabs');
      const tabs = Array.from(this.querySelectorAll('.hf-discovery__tab'));
      const panels = Array.from(this.querySelectorAll('.hf-discovery__panel'));
      if (!nav || tabs.length !== panels.length || !tabs.length) return;
      const activate = (tab, focus = false) => {
        tabs.forEach((item, index) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          panels[index].hidden = !selected;
        });
        if (focus) tab.focus({ preventScroll: true });
      };
      nav.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          event.preventDefault();
          activate(tab);
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
      const linkedPanel = panels.find(panel => '#' + panel.id === window.location.hash);
      const initial = tabs.find(tab => tab.dataset.category === (linkedPanel?.dataset.category || this.dataset.defaultCategory)) || tabs[0];
      activate(initial);
      this.dataset.enhanced = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
